import { Component, OnInit, ElementRef } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { Observable } from 'rxjs';

@Component({
  selector: 'mutara-radio-group',
  styleUrls: ['./radio-group.component.scss'],
  templateUrl: './radio-group.component.html',
  standalone: false
})

export class RadioGroupComponent extends FieldType<FieldTypeConfig> implements OnInit {
  optionGroups: any;
  optionList: Observable<any[]> | undefined;
  collapse: any = {};
  groupOrder: any = {};
  isEmpty: boolean = false;
  hasGroups: boolean = false;

  constructor( public host: ElementRef) { super(); }

  get debug(): boolean {
    return this.props?.capForm?.debug ?? false;
  }
  
  get currentValue(): string {
    return this.props.sortableOptions.selectedValue;
  }

  ngOnInit(): void {
    this.optionList = this.props.sortableOptions.obsOptions.asObservable();
    this.props.sortableOptions.selectedValue = this.props.getValue();

    this.optionList?.subscribe({
      error: (err) => {
        console.log('Problem processing radios %O', err);
      },
      next: (opts) => {
        this.isEmpty = (opts.length == 0);
        this.optionGroups = {};
        this.groupOrder = {};
        opts.forEach(opt => {
          let matches = opt?.label?.match(/(?:{{(?<default>\w*)}})/), newValue;
          if (!!matches) {
            const defaultOptions = this.defaultOptions as Record<string, any> | undefined;
            Object.keys(matches.groups ?? {}).forEach((matchValue: string) => {
              let newValue: string | undefined;
              newValue = opt.label.replace('{{' + matchValue + '}}', defaultOptions?.[matchValue] ?? '');
            });
          }

          if (!!opt.category) {
            let cat = opt.category.split('|'), group = this.optionGroups[cat[0]];
            if (!group) {
              group = this.optionGroups[cat[0]] = [];
              if (cat.length > 1) {
                this.groupOrder[parseInt(cat[1])] = cat[0];
              }
              if (cat.length > 2) {
                this.collapse[cat[0]] = cat[2];
              }
            }
            group.push(opt);
            this.hasGroups = true;
          } else {
            this.hasGroups = false;
            let group = this.optionGroups[''];
            if (!group) {
              group = this.optionGroups[''] = [];
              this.groupOrder[''] = '';
            }

            group.push(opt);
          }
        });
        if (this.debug) console.log('Group %O Options %O => %O', this.props.sortableOptions.selectedValue = this.currentValue, this.sortedGroups(), this.optionGroups);
      }
    });
    this.onRadioChange({ value: this.currentValue });
  }

  isChecked(optionValue: string): boolean {
    return this.currentValue == optionValue;
  }
  sortedGroups() {
    return Object.keys(this.groupOrder).sort();
  }
  checkRequired() {
    if (this.props.required) {
      this.formControl.setErrors(!this.currentValue ? { required: 'Please select a value for ' + this.props.label } : null);
    }
  }
  onRadioChange($event: any) {
    this.field.formControl.setValue($event.value);
    this.props.sortableOptions.selectedValue = $event.value;
    this.checkRequired();
    console.log('Radio value changing %O(%O)', this.field.key, $event.value);
   // this.field.props?.capForm?.cdr?.markForCheck();
  }
}